var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetpasswordPana({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.46,100.81l-2-3.28c-16.78-27.66-47.12-44.33-79.11-42.3a83,83,0,0,0-12.24,1.68C269,63.13,243.73,85.13,233.24,113.3c-6.17,16.56-7.89,35.63-19.6,48.78C198.4,179.2,172.54,179.73,149.8,179s-48.63-.1-63.79,17.08c-9.5,10.76-12.51,26.06-11.75,40.47,2,38.15,28.61,72.26,62.42,89.22s73.61,18.47,110.61,11c51.83-10.45,101.12-39.14,130.75-83.46S415.17,148.64,391.46,100.81Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.42,413.6,42.45,438l30.26,22.52c2-3-9.37-20.48-9.37-20.48L75.5,424.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,431.78a1.53,1.53,0,0,0-1.9.77,1.49,1.49,0,0,0,.75,1.9,1.62,1.62,0,0,0,2-.83,1.54,1.54,0,0,0-1-1.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.41,438.06l1.91-2.62L72.59,458.2s.9,1.6,0,2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,440.26c-.11.15-.9-.33-2-.4s-1.93.27-2,.11.77-.85,2.07-.75S64.08,440.15,64,440.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.15,443.94c-.08.17-.9-.06-1.87.19s-1.6.81-1.75.69.39-1,1.6-1.31S66.25,443.8,66.15,443.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.12,449.08c-.16-.07.19-1,1.17-1.49s1.91-.33,1.88-.16-.78.28-1.57.73S65.28,449.17,65.12,449.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.34,436.5c-.17.09-.69-.62-1.57-1.18s-1.72-.79-1.71-1,1-.25,2.06.43S66.5,436.44,66.34,436.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.58,311.46c.54,3.06,1.4,29.09,1.95,42.82s-.82,20.48-2.39,23.56S72.36,424.55,67.85,435l-15-12.09s22-39.49,31.38-46.67,27.43-13.77,27.43-13.77l-5.13-75.19,24.59-1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.55,437.73,78.29,468l37.71.52c-.17-3.6-19.58-11.11-19.58-11.11l1-19.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,455.66a1.54,1.54,0,0,0-1.09,1.74,1.49,1.49,0,0,0,1.72,1.1,1.63,1.63,0,0,0,1.14-1.85,1.53,1.53,0,0,0-1.91-.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.28,468.11l0-3.25,36.25,1.88s1.66.77,1.45,1.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,457.27c0,.19-.93.26-1.84.84s-1.41,1.34-1.58,1.27.12-1.14,1.24-1.82S97.08,457.1,97,457.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,459c0,.18-.77.48-1.4,1.25s-.83,1.6-1,1.58-.29-1.05.52-2S101,458.79,101,459Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.15,463.73c-.17,0-.41-.89.07-1.89s1.36-1.39,1.43-1.24-.46.69-.85,1.52S103.33,463.71,103.15,463.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.76,452.82c-.08.17-.92-.1-2,0s-1.86.37-2,.21.69-.8,1.92-.85S96.85,452.68,96.76,452.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,282.83c0,1.77,2.87,46.58-11.78,79,0,0-5.07,10.14-6,14.57s-19.88,77.91-19.88,77.91l-21.9-.8s-3.5-36.81,0-58.12,10-18.81,10-32.57-3.27-42.29-3.27-42.29-4.78-7.79-6.41-22.9c-1.33-12.27,4.45-25.42,4.45-25.42l5.71-10.11,48.31-2.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,282.83s0-.52,0-1.53-.06-2.51-.1-4.48c-.09-3.95-.24-9.77-.42-17.29v-.11h-.12l-48.31,2.46h-.1l-.06.09c-1.77,3.14-3.72,6.57-5.72,10.11h0A64.71,64.71,0,0,0,78,283.18a49.43,49.43,0,0,0-1.21,12.19,75.39,75.39,0,0,0,2,12.69,51.57,51.57,0,0,0,4.63,12.57l0-.1c.83,7.46,1.6,15.19,2.25,23.15.32,4,.6,8,.8,12.11.1,2,.18,4.1.19,6.17,0,1,0,2.07-.06,3.1a28.78,28.78,0,0,1-.38,3.08A20.24,20.24,0,0,1,84.07,374c-1,1.87-2,3.72-3,5.67a53.33,53.33,0,0,0-3.93,12.4c-1.74,8.6-2.09,17.54-2.19,26.55,0,11.89.56,23.57,1.54,34.86l0,.24h.23l21.9.8h.21l.05-.21c6.35-24.61,12.27-47.61,17.49-68.29l1.89-7.65c.33-1.27.54-2.53.93-3.73s.83-2.39,1.29-3.55c.94-2.32,2-4.57,3-6.76l.78-1.63a16.11,16.11,0,0,0,.74-1.64c.45-1.11.9-2.2,1.35-3.29a132.68,132.68,0,0,0,6.91-24.93,216.82,216.82,0,0,0,3.3-36.74c.06-8.62-.29-13.3-.29-13.3s0,.29,0,.86,0,1.44.06,2.56c.06,2.25.1,5.57,0,9.88A222.45,222.45,0,0,1,133,332.81a132.6,132.6,0,0,1-7,24.84l-1.34,3.27c-.22.56-.47,1.09-.74,1.63s-.53,1.09-.79,1.64c-1,2.19-2.06,4.44-3,6.77-.47,1.17-.92,2.36-1.31,3.58s-.62,2.51-.94,3.75c-.63,2.52-1.26,5.06-1.91,7.65-5.31,20.66-11.22,43.66-17.55,68.27l.26-.19-21.9-.81.26.24c-1-11.27-1.58-22.94-1.54-34.81.1-9,.45-17.9,2.18-26.44a53.51,53.51,0,0,1,3.89-12.29c.9-1.93,2-3.76,3-5.66a20.91,20.91,0,0,0,2.12-6,27.93,27.93,0,0,0,.39-3.15c0-1,.1-2.1.06-3.13,0-2.08-.09-4.15-.19-6.2-.2-4.1-.49-8.14-.82-12.12q-1-12-2.27-23.17v0l0-.06A51,51,0,0,1,79.21,308a75.55,75.55,0,0,1-2-12.6,49.11,49.11,0,0,1,1.18-12.08,65.65,65.65,0,0,1,3.39-11v0l5.7-10.12-.16.1,48.31-2.61-.13-.11c.24,7.51.42,13.33.54,17.28.07,2,.12,3.46.16,4.48S136.3,282.83,136.3,282.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59,191.07s-13-2.3-11.79,14.43c.76,10,3.7,27.16,5.33,38.11.56,3.79,1.8,10.57,6.81,14.55L156.84,283l11.33-13.55-32.06-30.53-5-30.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.12,130.77a16.46,16.46,0,0,1,6.1,13.92c-.2,2.56-.91,5.47.76,7.42s4.87,1.88,6.45,3.86c1.85,2.34.3,5.82,1,8.73a5.92,5.92,0,0,0,6.29,4.39,23.09,23.09,0,0,1-11.44,5L128,170c1.22,1.44.89,3.73-.28,5.2A9.7,9.7,0,0,1,123,178a29.29,29.29,0,0,1-25.65-4.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09,153.34c.64-2,1.72-3.77,2.15-5.78.92-4.33-1.19-9.21.91-13.11,1.5-2.77,4.68-4.13,7.7-5.06s6.24-1.71,8.49-3.92c1.64-1.62,2.58-3.86,4.22-5.48,2.34-2.32,5.8-3.11,9.08-3.31a19.72,19.72,0,0,1,9.91,1.61,10.82,10.82,0,0,1,6.1,7.63c.26,1.62.06,3.33.58,4.9.56,1.72,1.91,3.06,2.75,4.67a8.68,8.68,0,0,1-2.17,10.4l-23.18,29.94c-4.87,1.84-16.67-.38-20.43-4S72.48,158.29,74.09,153.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2,142.09c-1-6.8-6.13-14.83-12.88-13.59l-20.84,7c-2,.38-.58,3.73-.38,5.8l4.53,47s-2.82,2-3.82,1.62a.29.29,0,0,0-.34.43C92,194,103.79,209.87,116,205c2.72-1.09-.29-9.66,0-12.83l-.36-8.11c-.27-4.14-.4-5.84-.4-5.8s8.62-2.12,9.55-13.65C125.26,158.9,124.26,149.64,123.2,142.09Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,152.55a1.47,1.47,0,0,1-1.3,1.58,1.4,1.4,0,0,1-1.61-1.2,1.47,1.47,0,0,1,1.3-1.58A1.4,1.4,0,0,1,121.75,152.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.55,153.44a1.46,1.46,0,0,1-1.29,1.58,1.41,1.41,0,0,1-1.61-1.2,1.47,1.47,0,0,1,1.3-1.58A1.39,1.39,0,0,1,107.55,153.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,147.73c-.16.27-1.52-.59-3.22-.34s-2.79,1.41-3,1.2,0-.56.49-1.09a3.89,3.89,0,0,1,5-.69C122.1,147.2,122.35,147.61,122.27,147.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,149c-.2.25-1.53-.72-3.36-.64s-3.13,1.11-3.34.88.09-.54.66-1a4.38,4.38,0,0,1,2.65-1,4.34,4.34,0,0,1,2.7.81C106.88,148.46,107.09,148.88,107,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.73,159.77a9.94,9.94,0,0,1,2.52-.66c.39-.07.77-.18.81-.46a2,2,0,0,0-.36-1.17c-.45-.94-.92-1.93-1.42-3-2-4.23-3.45-7.71-3.28-7.79s1.92,3.28,3.9,7.5c.48,1.05.94,2,1.37,3a2.3,2.3,0,0,1,.33,1.56,1,1,0,0,1-.61.64,2.77,2.77,0,0,1-.67.14A11,11,0,0,1,112.73,159.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24,178.28a29.06,29.06,0,0,1-15.56-2.9s4.45,7.7,15.76,5.76Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.94,164.35a2.58,2.58,0,0,1,.8-1,2,2,0,0,1,1.36-.13,3.14,3.14,0,0,1,1.78.9,1.91,1.91,0,0,1,.45,1.88h0c-.18.66-1.16,1-1.83,1.14a3,3,0,0,1-2-.41,1.75,1.75,0,0,1-1-1.3A2.15,2.15,0,0,1,107.94,164.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.26,162.14c.25,0,.39,1.67,1.94,2.77s3.35.77,3.38,1-.37.36-1.14.44a4.24,4.24,0,0,1-2.82-.75,3.67,3.67,0,0,1-1.52-2.33C108,162.58,108.14,162.14,108.26,162.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86,142.85c-.13.43-1.71.35-3.54.72s-3.28,1-3.55.61c-.12-.17.1-.59.67-1.05a6.22,6.22,0,0,1,5.4-1C106.54,142.33,106.91,142.64,106.86,142.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,142c-.29.38-1.55.11-3,.21s-2.73.45-3.05.1c-.14-.17,0-.55.55-.93a4.68,4.68,0,0,1,2.43-.77,4.55,4.55,0,0,1,2.48.53C121.23,141.44,121.43,141.8,121.3,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,137.14c1-1.62,2.94-2.45,4.74-3.14a104.89,104.89,0,0,1,24.14-6.15c1,1.69.08,4-1.47,5.23s-3.55,1.72-5.4,2.41-3.76,1.77-4.53,3.6-.12,4.24-.84,6.22c-1.23,3.42-6,4.52-7.19,7.93-.92,2.59.58,5.34,1,8.06a9.8,9.8,0,0,1-9.62,11.15q-.84-14.69-1.69-29.36C83.84,141.05,83.76,138.85,84.87,137.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,161.87c1.55-1.39,3.49-2.59,4.1-4.57.9-2.89-1.42-6.28.08-8.91,1.36-2.4,5.37-2.27,6.64-4.72,1-1.92-.15-3.61.22-5.29s2.77-3.15,4.47-2.95L94,154.8c1.24,6.5,2.49,10,1.1,13.76a30.36,30.36,0,0,0-2.07,6.32c-.3,2.2.27,4.69,2.06,6-8,.63-15.48-3.55-22.4-7.6L65.4,169a5.23,5.23,0,0,1-2-1.68C62.31,165.54,63.61,163.25,65.15,161.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.52,171.31a3.79,3.79,0,0,0,.86.17,7.49,7.49,0,0,0,2.49-.18,7.69,7.69,0,0,0,3.47-1.87,7.57,7.57,0,0,0,2.28-4.67,7.73,7.73,0,0,0-.26-3.07,12.67,12.67,0,0,0-1.48-3,11.51,11.51,0,0,1-1.53-3.08,3.94,3.94,0,0,1,.43-3.39c.72-1,2.07-1.21,3.33-1.71a3.63,3.63,0,0,0,1.7-1.27,3.59,3.59,0,0,0,.55-2.09,22.81,22.81,0,0,0-.91-4.16,4.4,4.4,0,0,1,0-2,2.87,2.87,0,0,1,1.15-1.63,8.08,8.08,0,0,1,4-1.08,8.59,8.59,0,0,0,4.12-1.21A7.71,7.71,0,0,0,95.57,134a12.65,12.65,0,0,0,1-3.83,18.37,18.37,0,0,1,.78-3.6,8.16,8.16,0,0,1,1.88-2.83,9.24,9.24,0,0,1,5.53-2.5,9.14,9.14,0,0,1,5,1,11,11,0,0,1,3.08,2.34,14.53,14.53,0,0,1,1.9,2.73s0-.07-.07-.21a5.57,5.57,0,0,0-.28-.58A10.37,10.37,0,0,0,113,124.5a11.18,11.18,0,0,0-3.1-2.45,9.3,9.3,0,0,0-5.09-1.13A9.5,9.5,0,0,0,99,123.47a8.46,8.46,0,0,0-2,3,18.62,18.62,0,0,0-.82,3.67,12.35,12.35,0,0,1-1,3.7,7.32,7.32,0,0,1-2.66,2.87,8.25,8.25,0,0,1-3.92,1.13A8.41,8.41,0,0,0,84.32,139,3.27,3.27,0,0,0,83,140.86a4.88,4.88,0,0,0,0,2.25,22.94,22.94,0,0,1,.9,4.08,3.09,3.09,0,0,1-.46,1.83,3.32,3.32,0,0,1-1.51,1.11c-.59.25-1.23.42-1.85.68A3.9,3.9,0,0,0,78.43,152a4.43,4.43,0,0,0-.48,3.76,12.16,12.16,0,0,0,1.6,3.18A12,12,0,0,1,81,161.8a7.55,7.55,0,0,1,.28,2.92,7.36,7.36,0,0,1-2.14,4.52,7.55,7.55,0,0,1-3.34,1.88A8.37,8.37,0,0,1,72.52,171.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,157.54a1.7,1.7,0,0,0-.26.65,2.88,2.88,0,0,0,.34,2,3.13,3.13,0,0,0,1,1.07,3.19,3.19,0,0,0,1.71.46,4,4,0,0,0,3.5-2.23,5.31,5.31,0,0,0,.57-2.43,7.44,7.44,0,0,0-.56-2.64c-.63-1.73-1.79-3.42-1.81-5.44a3.71,3.71,0,0,1,.93-2.75,4,4,0,0,1,2.9-.9,9.9,9.9,0,0,0,3.46-.36,3,3,0,0,0,1.42-1.2,4.32,4.32,0,0,0,.59-1.76,13.83,13.83,0,0,0-.29-3.56,7.57,7.57,0,0,1,.19-3.29,8.28,8.28,0,0,1,3.71-4.88A11.77,11.77,0,0,1,84.83,129a16.17,16.17,0,0,0,5.06-.8A10.61,10.61,0,0,0,93.47,126a10.48,10.48,0,0,0,2-2.52,7.41,7.41,0,0,0,.95-2.53,15.26,15.26,0,0,1-1.11,2.44,10.75,10.75,0,0,1-5.5,4.56,16.48,16.48,0,0,1-5,.72,12,12,0,0,0-5.74,1.28A8.68,8.68,0,0,0,75.13,135a8.11,8.11,0,0,0-.21,3.47,14.42,14.42,0,0,1,.29,3.44,3,3,0,0,1-1.73,2.59,9.41,9.41,0,0,1-3.29.33,4.43,4.43,0,0,0-3.21,1,4.09,4.09,0,0,0-1,3.07,7.92,7.92,0,0,0,.73,3c.39.9.82,1.74,1.15,2.58a7.21,7.21,0,0,1,.56,2.51,5.05,5.05,0,0,1-.5,2.28,3.71,3.71,0,0,1-3.21,2.12,3,3,0,0,1-1.59-.39,2.78,2.78,0,0,1-1-1,2.82,2.82,0,0,1-.41-1.87C61.76,157.77,61.89,157.55,61.86,157.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,162.31a3.15,3.15,0,0,1,0,2.09,2.73,2.73,0,0,1-1.66,1.69,2.89,2.89,0,0,1-2.93-.8,2.66,2.66,0,0,1-.69-1.68,5.59,5.59,0,0,1,.31-2c.42-1.35,1.29-2.82,1.16-4.59a6.47,6.47,0,0,0-2.44-4.62,7.42,7.42,0,0,0-2.49-1.31,11.33,11.33,0,0,0-2.84-.41,14.52,14.52,0,0,1-2.77-.29,3.68,3.68,0,0,1-2.15-1.33,4.48,4.48,0,0,1-.77-2.37,9.17,9.17,0,0,1,.2-2.46,18.55,18.55,0,0,0,.72-4.68,7.09,7.09,0,0,0-1.43-3.88,9.08,9.08,0,0,0-2.6-2.2,18.43,18.43,0,0,1-2.09-1.44,5.24,5.24,0,0,1-1.3-1.68s0,0,0,.14a2,2,0,0,0,.16.39,4.32,4.32,0,0,0,1,1.28,16.15,16.15,0,0,0,2.07,1.53,9,9,0,0,1,2.48,2.18,6.7,6.7,0,0,1,1.3,3.7,18.67,18.67,0,0,1-.75,4.57,9.55,9.55,0,0,0-.23,2.58,5,5,0,0,0,.86,2.61,4.12,4.12,0,0,0,2.4,1.51,15.25,15.25,0,0,0,2.85.31,11.12,11.12,0,0,1,2.74.38,7.28,7.28,0,0,1,2.34,1.23,6.06,6.06,0,0,1,2.29,4.29c.14,1.61-.66,3-1.1,4.45a6,6,0,0,0-.3,2.16,3,3,0,0,0,.81,1.87,3.17,3.17,0,0,0,3.26.83,2.92,2.92,0,0,0,1.74-1.88,2.88,2.88,0,0,0,.08-1.62A1.69,1.69,0,0,0,146.09,162.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53,240.64V229.58c1.24-6.21.65-13.57-2.24-19.24a103.56,103.56,0,0,0-6.94-10.55l-11-14.29c-6.06,4.41-15.55,1.22-23.69-1.74,0,0-8,4.45-11.78,8.63-3.93,4.4,9.51,59.45,9.51,59.45-6.09,12.18-13.95,23-15.14,34.1l63.6,2.45-2.7-29.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.65,259.54a5.61,5.61,0,0,1-.05-1.25c0-.91,0-2,0-3.39.05-3,.11-6.87.18-11.18s.2-8.32.34-11.18c.07-1.43.14-2.59.2-3.39a5.52,5.52,0,0,1,.16-1.23,6.35,6.35,0,0,1,0,1.24c0,.91,0,2,0,3.39-.05,3-.12,6.87-.19,11.18s-.19,8.32-.33,11.18c-.07,1.43-.14,2.59-.21,3.39A5.28,5.28,0,0,1,135.65,259.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,269.6s6.2.34,10,2.74,10,6.14,12.55,10.77c1.17,2.13-2.16,2.58-3.81,1.35s-4.16-3.57-5.41-3.85l-1.25-.29a83.39,83.39,0,0,0,3.81,7.56c1.29,2,2.41,5.32-1.47,5.47,0,0-2.61,3.4-5.25.88,0,0-2.06,3.09-5.38-1.19,0,0-1.94,2.45-2.74,1.51s-3.45-2.42-4.22-5.48a110.89,110.89,0,0,0-4-10.49Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.51,183.66c.69,0,29.08-3,29.08-3s2.41-11.54,2.28-14.54-2.15-22.85-2.15-22.85l10.63-5s14.21,47.92,11.11,51.9-8.93,7.55-9.43,7.57-27.51,12-46.3,5.77S303.51,183.66,303.51,183.66Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.63,209.53c4.18,4.15,11.38,7.6,23.4,4.6,23.76-5.94,41.57-11,48.65-14.8s4.32-20.78,4.92-21.55c1.79-2.32-.18-7.3-2.73-8.08-7.27-2.2-19.92-1.33-20.56-.67-3.73,3.92-.33,8.68-.33,8.68l-31.33,4.11a52.44,52.44,0,0,0-11.51.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.14,182.55l.75-.16c.5-.09,1.24-.22,2.22-.34a51.51,51.51,0,0,1,8.55-.36h0l31.32-4.2-.15.35a8.39,8.39,0,0,1-1.44-5.15,6,6,0,0,1,.9-2.66,8.51,8.51,0,0,1,.86-1.14,1.62,1.62,0,0,1,.41-.22l.36-.09c.24-.06.47-.08.7-.13a62.11,62.11,0,0,1,11.69-.24,40.19,40.19,0,0,1,6.08.84c.5.11,1,.26,1.52.39a3.76,3.76,0,0,1,1.43.84,7,7,0,0,1,1.77,2.72,6.87,6.87,0,0,1,.41,3.25,4,4,0,0,1-.63,1.6c-.09.1-.08.37-.09.63v.8c.07,2.15.17,4.34.11,6.54A27.8,27.8,0,0,1,354.4,195a9.09,9.09,0,0,1-2.6,3.83,8.93,8.93,0,0,1-2,1.18c-.66.35-1.36.62-2,.94-2.74,1.17-5.49,2.13-8.2,3s-5.37,1.71-8,2.48c-10.46,3-20,5.43-27.94,7.42a53.77,53.77,0,0,1-5.76,1.19,30.9,30.9,0,0,1-5.25.28,21.89,21.89,0,0,1-8.19-1.78,18.85,18.85,0,0,1-4.5-2.8,11.72,11.72,0,0,1-1.34-1.27s.46.44,1.41,1.19a19.59,19.59,0,0,0,4.52,2.7,22.11,22.11,0,0,0,8.11,1.67,30.42,30.42,0,0,0,5.19-.32,54.54,54.54,0,0,0,5.72-1.22c8-2,17.46-4.46,27.89-7.52,2.61-.77,5.27-1.59,8-2.49s5.44-1.85,8.15-3c.66-.31,1.35-.58,2-.93a8.75,8.75,0,0,0,1.87-1.12,8.51,8.51,0,0,0,2.45-3.61,27.55,27.55,0,0,0,1.45-9.05c.06-2.19,0-4.36-.11-6.52v-.82c0-.14,0-.28,0-.43a1.2,1.2,0,0,1,0-.24,1.42,1.42,0,0,1,.08-.18l.05-.08a3.29,3.29,0,0,0,.54-1.37,6.26,6.26,0,0,0-.39-3,6.48,6.48,0,0,0-1.62-2.52,3.28,3.28,0,0,0-1.24-.73c-.5-.13-1-.27-1.49-.39a39.88,39.88,0,0,0-6-.83,60.8,60.8,0,0,0-11.57.22c-.23,0-.46.06-.68.12l-.32.07a1.24,1.24,0,0,0-.2.1,7.44,7.44,0,0,0-.81,1.06,5.36,5.36,0,0,0-.84,2.45,8,8,0,0,0,1.34,4.85l.2.31-.35,0-31.34,4h0a54,54,0,0,0-8.51.24c-1,.1-1.73.21-2.23.28S289.14,182.55,289.14,182.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.76-10.51H337a0,0,0,0,1,0,0V265.73a12,12,0,0,1-12,12h-2.25a12,12,0,0,1-12-12V-10.51a0,0,0,0,1,0,0Z",
    transform: "translate(364.63 481.54) rotate(-119.1)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61,51.48h60.77a2.24,2.24,0,0,1,2.24,2.24V69.24a2.24,2.24,0,0,1-2.24,2.24H368.61a0,0,0,0,1,0,0v-20A0,0,0,0,1,368.61,51.48Z",
    transform: "translate(541 440.98) rotate(-119.1)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.68,
    y: 73.63,
    width: 50.77,
    height: 20,
    rx: 3.24,
    transform: "translate(474.01 445.9) rotate(-119.1)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.11,
    y: 55.78,
    width: 27.42,
    height: 31.06,
    transform: "translate(514.13 444.85) rotate(-119.1)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.39,59.86c.07.12-47.3,26.62-105.78,59.18s-106,58.86-106,58.73,47.29-26.62,105.79-59.19S429.32,59.73,429.39,59.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56,259.41c17.8,32,55.33,45,83.83,29.15s37.2-54.65,19.4-86.61-55.32-45-83.83-29.15S88.77,227.45,106.56,259.41Zm87.79-48.86c12.47,22.4,6.38,49.57-13.6,60.68s-46.27,2-58.74-20.42-6.38-49.57,13.59-60.69S181.88,188.15,194.35,210.55Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.93,
    y: 170.53,
    width: 40.12,
    height: 14.26,
    rx: 6.52,
    transform: "translate(208.91 478.13) rotate(-119.1)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.23,
    y: 156.45,
    width: 40.12,
    height: 14.26,
    rx: 6.52,
    transform: "translate(258.81 479.31) rotate(-119.1)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,162c.13-.07,3.18,5.3,6.83,12s6.5,12.16,6.37,12.23-3.18-5.29-6.83-12S244.23,162,244.36,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75,170.25c.13-.07,3.11,5.06,6.67,11.44s6.33,11.63,6.21,11.7S242.52,188.33,239,182,232.63,170.32,232.75,170.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,148.07c.13-.07,3.24,5.27,6.95,11.93s6.61,12.13,6.48,12.2-3.23-5.28-6.94-11.94S269.69,148.14,269.81,148.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,155.44c.12-.07,3.17,5.24,6.79,11.86s6.47,12,6.34,12.11-3.16-5.24-6.79-11.86S257.47,155.51,257.6,155.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.13,119.37a4.72,4.72,0,0,0,2-9.18,4.92,4.92,0,0,0-4.27-8.3A5.89,5.89,0,0,0,319,97.05a6.62,6.62,0,0,0-8.15-.18,4.71,4.71,0,0,0-4.17,8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.84,101.53h1A20.06,20.06,0,0,1,330.82,120c.75,9.69,1.45,20.4,1.37,25.6C332,156.4,321.26,158,321.26,158l.87,12.94L296,170.09l-2.17-46.9C292.91,112,298.64,102.15,309.84,101.53Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.35,158a26.13,26.13,0,0,1-14.09-4.17s3.46,8.15,14.2,7.21Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.91,130.15a1.53,1.53,0,0,1-1.49,1.54,1.48,1.48,0,0,1-1.58-1.39,1.55,1.55,0,0,1,1.49-1.55A1.48,1.48,0,0,1,324.91,130.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.49,125.29c-.19.2-1.36-.66-3-.66s-2.87.82-3.05.62.11-.45.64-.84a4.21,4.21,0,0,1,2.44-.74,4,4,0,0,1,2.39.78C328.41,124.84,328.58,125.21,328.49,125.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,129.43A1.54,1.54,0,0,1,308.5,131a1.48,1.48,0,0,1-1.58-1.39,1.54,1.54,0,0,1,1.49-1.55A1.48,1.48,0,0,1,310,129.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23,125.55c-.19.2-1.36-.66-3-.66s-2.87.82-3.05.62.11-.45.64-.84a4.21,4.21,0,0,1,2.44-.74,4,4,0,0,1,2.39.78C312.15,125.1,312.32,125.46,312.23,125.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,137.84a10.7,10.7,0,0,1,2.69-.48c.42,0,.82-.12.9-.41a2.16,2.16,0,0,0-.28-1.25l-1.24-3.22c-1.72-4.59-3-8.36-2.78-8.42s1.73,3.59,3.45,8.17c.41,1.13.81,2.21,1.19,3.24a2.49,2.49,0,0,1,.21,1.66,1.06,1.06,0,0,1-.7.61,2.42,2.42,0,0,1-.71.1A11,11,0,0,1,318.19,137.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,119.19c-.22.42-1.63,0-3.38-.1s-3.21.23-3.37-.21c-.07-.21.24-.58.87-.92a5.29,5.29,0,0,1,2.62-.54,5.08,5.08,0,0,1,2.53.78C313.52,118.59,313.78,119,313.68,119.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.59,118.48c-.35.37-1.72,0-3.36,0s-3,.25-3.35-.15c-.14-.19.08-.57.69-.92a5.38,5.38,0,0,1,2.73-.61,5.26,5.26,0,0,1,2.67.77C328.55,117.91,328.74,118.29,328.59,118.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.8,115.1s-2.82-6.75-6.07-8.33c-3.93-1.92-5.63,2.39-9.38,1.33s-7.5-2.89-11.34,0c-4.2,3.16-2.24,5.39-2.52,10.17-1.1,19.36-4.66,24.82-5.63,15.7-.11-1-2.88-1.8-3.28-6-.52-5.47-.71-12.12.53-16,1-3.27,2.91-5.53,6.26-8,5.3-3.92,12.56-4,17.49-3.47S330.27,106.66,329.8,115.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.54,133.67a2.92,2.92,0,0,0-3.14-2.83c-2,.19-4.25,1.32-4.13,5.47.21,7.36,7.56,5.63,7.57,5.41S295.66,136.75,295.54,133.67Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,139s-.12.1-.34.2a1.29,1.29,0,0,1-.95.05,3.16,3.16,0,0,1-1.55-2.81,4.22,4.22,0,0,1,.3-1.84,1.47,1.47,0,0,1,.94-1,.65.65,0,0,1,.77.33c.1.2.06.35.1.36s.15-.13.08-.43a.74.74,0,0,0-.3-.45.94.94,0,0,0-.71-.17,1.8,1.8,0,0,0-1.31,1.18,4.32,4.32,0,0,0-.39,2.06c.09,1.48.89,2.85,2,3.13a1.35,1.35,0,0,0,1.16-.23C294.15,139.18,294.18,139,294.15,139Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.73,119.41a7,7,0,0,0,3.11,1.45,2.4,2.4,0,0,0,2.67-1.68c.09-.51,0-1.11.3-1.5s1.15-.32,1.76-.25c2.14.23,4.65-2.13,5.2-4.21a1.91,1.91,0,0,0,2.56.54,6.84,6.84,0,0,0,1.78-1.57,3.05,3.05,0,0,1,2.53-1.25,7,7,0,0,0,1.6.35c1-.08,1.44-1.21,1.59-2.17s.27-2.07,1.09-2.59a3.87,3.87,0,0,1,2.63-.07c.89.14,2-.07,2.27-.94a1.76,1.76,0,0,0-.33-1.33,4.76,4.76,0,0,0-5.62-1.82A6.45,6.45,0,0,0,307,101.08a6.55,6.55,0,0,0-10.49,2.36,4.75,4.75,0,0,0-5.38,6.89,4.51,4.51,0,0,0-2.49,3.59c0,1.52,1.45,3,2.92,2.64a2.63,2.63,0,0,0,4.54,2.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.41,104.53s0,0,0,.14,0,.22-.05.39a4.79,4.79,0,0,1-.54,1.42,5.33,5.33,0,0,1-1.63,1.73,4.92,4.92,0,0,1-3,.85l.12-.16a2.63,2.63,0,0,1-.15,2,7.59,7.59,0,0,1-1.26,1.8,5.52,5.52,0,0,1-.83.85,2.75,2.75,0,0,1-3.53-.43l.27-.08a5.51,5.51,0,0,1-2.35,3.81,4,4,0,0,1-2.42.79,7.44,7.44,0,0,1-2.38-.53l.2-.09a5.83,5.83,0,0,1-1.75,2.27,3.08,3.08,0,0,1-2.56.69,4.06,4.06,0,0,1-3.12-3.18l.17.08a3.87,3.87,0,0,1-2.53.36,4.17,4.17,0,0,1-1.76-.79,3.67,3.67,0,0,1-.82-.9,1.32,1.32,0,0,1-.18-.39,4.32,4.32,0,0,0,1.07,1.19,4,4,0,0,0,1.72.71,3.58,3.58,0,0,0,2.39-.38l.14-.08,0,.16a3.8,3.8,0,0,0,2.94,2.94,2.81,2.81,0,0,0,2.33-.65,5.52,5.52,0,0,0,1.64-2.15l.06-.13.14,0a7.05,7.05,0,0,0,2.27.5,3.71,3.71,0,0,0,2.24-.73,5.23,5.23,0,0,0,2.22-3.59l0-.35.23.27a2.38,2.38,0,0,0,2.09.76,2.34,2.34,0,0,0,1-.38,4.87,4.87,0,0,0,.78-.79,7.33,7.33,0,0,0,1.24-1.72,2.39,2.39,0,0,0,.16-1.84l-.06-.18.19,0a4.72,4.72,0,0,0,2.89-.77,5.24,5.24,0,0,0,1.62-1.65A5.52,5.52,0,0,0,319.41,104.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.17,143.33c-.06-.27-1.85.17-3.51-1.05s-1.93-3.18-2.18-3.13-.25.52-.07,1.33a4.59,4.59,0,0,0,1.73,2.64,4,4,0,0,0,2.9.76C317.81,143.76,318.21,143.45,318.17,143.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.63,423.12l7.1,24.19s27,.9,28.73,5.25L363,468l-12.62-37.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.71,450.08a2,2,0,0,0-.59,2.6,1.92,1.92,0,0,0,2.57.61,2.11,2.11,0,0,0,.61-2.76,2,2,0,0,0-2.75-.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.84,450.81s2.37.21,2.62,1.75L363,468l-1.12-3.81,44.92-13.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4,446.82c.07.23-1,.71-1.9,1.81s-1.15,2.25-1.39,2.23-.33-1.44.75-2.75S381.38,446.6,381.4,446.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,447.21c.13.21-.72.92-1.18,2.13s-.33,2.31-.56,2.37-.8-1.17-.21-2.67S386.87,447,386.94,447.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,452.12c-.19.12-.88-.91-.71-2.34s1.06-2.29,1.22-2.13-.28,1-.4,2.22S391.87,452,391.65,452.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.17,441.49c0,.24-1.17.27-2.42.78s-2.12,1.25-2.3,1.1.51-1.28,2-1.87S379.23,441.27,379.17,441.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.29,423.33l-10.11,23.1s20.09,18,18.64,22.48l-45.5-18,14.27-36.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.89,438.9a2,2,0,0,0-2.12,1.61,1.93,1.93,0,0,0,1.58,2.12,2.12,2.12,0,0,0,2.24-1.72c0-1-.91-2.14-1.89-2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.93,465.89s1.68,1.69.89,3l-45.5-18,1.59-3.63,43,18.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,446.49c-.09.22-1.24-.12-2.62.16s-2.33,1-2.5.82.67-1.32,2.34-1.63S256.14,446.3,256,446.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,450.35c0,.23-1.14.23-2.27.87s-1.73,1.55-2,1.46.14-1.41,1.55-2.18S260.08,450.14,260,450.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.46,457.13c-.22,0-.09-1.26,1-2.25s2.28-1.07,2.3-.85-.88.62-1.73,1.45S260.69,457.2,260.46,457.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.73,441c-.17.16-1.07-.54-2.36-1s-2.42-.4-2.46-.63,1.21-.66,2.72-.16S257.91,440.84,257.73,441Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.32,296.43l-15.94,64.66s-28.75,48.4-33.62,72.62l26.3,10.34s19.13-46.65,24.74-55.21a68.93,68.93,0,0,1,8.66-10.67,16.65,16.65,0,0,0,4.37-7.56l12.07-46.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.53,286.09s2.22,17.32,18.89,25l35.12,57.2s2.75,18.6,8,34.27,15.86,45.87,15.86,45.87l28.89-10.8-18.41-62.94-3-21.83-28.66-73-24.62-14.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.53,286.09l.53-.36,1.59-1.06,6.24-4.12L307.55,265l.08-.05.08.05,24.64,14.73,0,0,0,.06,28.72,72.93v.05c.95,6.9,2,14.29,3,21.83v0c5,17,10.3,35.19,15.78,53.93q1.33,4.53,2.64,9l.07.23-.23.08-28.89,10.8-.25.09-.08-.25c-5-14.51-9.84-28.48-14.41-41.73-1.15-3.31-2.28-6.59-3.22-9.87s-1.79-6.54-2.56-9.76c-1.52-6.44-2.74-12.73-3.7-18.83l0,.08L294.3,311.15l.06.05a32.61,32.61,0,0,1-11-8.38,34.65,34.65,0,0,1-5.4-8.66,35.63,35.63,0,0,1-2-6c-.17-.68-.27-1.21-.33-1.57s-.07-.54-.07-.54,0,.18.11.53.17.88.36,1.57a36.6,36.6,0,0,0,2.06,5.92,34.89,34.89,0,0,0,5.42,8.57,32.65,32.65,0,0,0,11,8.28l0,0,0,0,35.19,57.16,0,0v.05c1,6.08,2.2,12.36,3.72,18.79.77,3.21,1.61,6.46,2.56,9.73s2.07,6.53,3.22,9.84c4.59,13.25,9.42,27.22,14.44,41.72l-.33-.15,28.89-10.8-.16.31q-1.3-4.47-2.64-9l-15.76-53.94v0c-1-7.54-2.06-14.93-3-21.83l0,.06-28.61-73,.08.09-24.6-14.79h.15L284,280.64l-6.3,4.06-1.62,1.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,162.52s-8.42,6.48-12.51,13.72c-4.9,8.67-5.43,21.52-5.58,41.48-.15,18.46,2.61,23.59,1.55,30.55-2.09,13.59-3.64,59.2-3.64,59.2s27-10.37,32.24-15l5.27-4.58,33.79,11.17-6.82-41.52-4.68-51.75-6-27.45-1-10.77L294.6,155.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,167c.35.07-.83,2.44-2.91,5.92l-.09.14-.16-.06c-2.93-1.14-6.81-2.57-11.05-4.12-4.78-1.74-9.1-3.36-12.19-4.62-1.55-.63-2.79-1.16-3.64-1.55a8.21,8.21,0,0,1-1.3-.64,7.12,7.12,0,0,1,1.38.46l3.69,1.39,12.24,4.47c4.24,1.55,8.11,3,11,4.24l-.24.08C321.44,169.3,322.73,167.05,322.53,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.45,145.44s-2.14-3.33-4.16-6.4-5.08-4.58-5.57-6.18-3.18-8.73-3.61-10.5a22.79,22.79,0,0,1-.52-5.22s2.21-.94,3.27,2.22c.64,1.9,2.68,8.35,3.12,8.67s1-.15,1-.15a75.77,75.77,0,0,1-2.35-7.37c-.1-1.17.31-8.93.31-8.93a2.34,2.34,0,0,1,2.66,1.49c1.05,2,1.09,7,1.09,7l1.59,5.58-.56-5.52.8-10.15a3.82,3.82,0,0,1,3.2,3c.67,2.74-.22,6.56.23,7.37s.94,5.71.94,5.71.55-11.9,1.82-12.24,2.31.92,2.13,3.32-.23,7.48.43,9.72,7.43,11,6.88,14.84a64.45,64.45,0,0,0-.63,7H357.92Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.76,175.41c.65.25,28.36,7.11,28.36,7.11s6.19-10,7.1-12.9S358,147.4,358,147.4l11.71-1.1s-3,49.89-7.24,52.58-11,4.05-11.44,3.9-29.95,1.9-45.5-10.35S316.76,175.41,316.76,175.41Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.9,201.82a21.16,21.16,0,0,0,11.33,6.66c7.35,1.62,23,4.49,23,4.49l-.76-7.68-34-3.64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M284.56,191.26c2.52,5.32,8.12,11,20.43,12.29,24.37,2.52,42.82,3.86,50.79,2.66s11.14-18.07,12-18.59c2.48-1.56,2.32-6.92.18-8.52-6.08-4.55-18.27-8-19.09-7.63-4.85,2.41-3.27,8.05-3.27,8.05L314.7,172.7a52,52,0,0,0-11.07-3.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.63,169.48s.26,0,.76.1,1.25.22,2.21.43a51.51,51.51,0,0,1,8.16,2.58h0l30.88,6.72-.26.28a8.31,8.31,0,0,1,.4-5.33,5.91,5.91,0,0,1,1.74-2.2,8.06,8.06,0,0,1,1.21-.78,1.69,1.69,0,0,1,.45-.07l.37,0c.25,0,.47.08.71.12a62,62,0,0,1,11.07,3.75,41.53,41.53,0,0,1,5.43,2.86c.43.28.86.59,1.29.89a3.7,3.7,0,0,1,1.06,1.27,7.09,7.09,0,0,1,.74,3.16,6.78,6.78,0,0,1-.72,3.2,3.8,3.8,0,0,1-1.14,1.29c-.12.06-.2.32-.3.56l-.26.75c-.66,2-1.32,4.14-2.12,6.2a28.11,28.11,0,0,1-4.54,8.16,8,8,0,0,1-6,3.14c-.75.11-1.5.13-2.24.19-3,.18-5.88.14-8.73.06s-5.64-.23-8.35-.4c-10.87-.7-20.62-1.69-28.8-2.54a52.53,52.53,0,0,1-5.82-.84,31,31,0,0,1-5-1.52,22.06,22.06,0,0,1-7.09-4.46,18.9,18.9,0,0,1-3.28-4.17,11.81,11.81,0,0,1-.83-1.65s.28.57.92,1.6a19.79,19.79,0,0,0,3.33,4.07,21.84,21.84,0,0,0,7.06,4.34,31.72,31.72,0,0,0,5,1.47,54.19,54.19,0,0,0,5.8.79c8.18.81,17.93,1.76,28.78,2.44,2.72.16,5.5.3,8.34.37s5.75.11,8.69-.06c.73-.07,1.48-.09,2.21-.2a8,8,0,0,0,2.14-.41,8.56,8.56,0,0,0,3.54-2.56,27.55,27.55,0,0,0,4.44-8c.8-2,1.45-4.11,2.11-6.17l.28-.78c0-.12.1-.25.16-.39a1.38,1.38,0,0,1,.13-.22.8.8,0,0,1,.13-.13l.07-.06a3.25,3.25,0,0,0,1-1.11,6.22,6.22,0,0,0,.66-3,6.62,6.62,0,0,0-.67-2.92,3.26,3.26,0,0,0-.91-1.1c-.43-.29-.84-.6-1.27-.87a39.84,39.84,0,0,0-5.36-2.83,61.38,61.38,0,0,0-10.95-3.74c-.23,0-.46-.1-.68-.12l-.33,0h-.22a7.69,7.69,0,0,0-1.12.73,5.41,5.41,0,0,0-1.63,2,8,8,0,0,0-.39,5l.09.35-.35-.08-30.83-6.9h0a54.65,54.65,0,0,0-8.08-2.68c-1-.23-1.69-.39-2.19-.49S303.63,169.48,303.63,169.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.78,189.17a6.55,6.55,0,0,1-2-.87,19.76,19.76,0,0,1-4.2-3.14,21,21,0,0,1-3.28-4.1,7.24,7.24,0,0,1-.95-2,44.3,44.3,0,0,0,4.59,5.69A40.94,40.94,0,0,0,355.78,189.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.22,271.53s6.2.33,10,2.74,10,6.13,12.55,10.77c1.17,2.13-2.16,2.58-3.8,1.34s-4.17-3.56-5.42-3.85l-1.25-.28a82.26,82.26,0,0,0,3.81,7.55c1.29,2,2.41,5.32-1.46,5.48,0,0-2.62,3.4-5.26.88,0,0-2.06,3.08-5.38-1.19,0,0-1.93,2.44-2.74,1.51s-3.45-2.42-4.22-5.48a107.06,107.06,0,0,0-4-10.49Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,190a14.92,14.92,0,0,0-7.79,5.85c-2.38,3.66-3.11,10-2.43,14.72,1.44,9.95,6,26.74,8.57,37.52.88,3.72,2.69,10.38,8,13.91l37.89,22.72,10.13-15-34.54-28.15-6.83-38.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.91,227.92a2.21,2.21,0,0,1,.12.39l.32,1.17c.27,1.06.65,2.58,1.15,4.53,1,4,2.42,9.68,4.19,16.75a19.61,19.61,0,0,0,6.24,9.88,37.53,37.53,0,0,0,5.54,3.68l6.09,3.68,27.29,16.48-.35.08,3.65-5.41,6.48-9.63.05.35-34.23-28.19-.06,0v-.07c-2.26-9.51-3.9-17.3-4.94-22.72-.51-2.71-.87-4.82-1.1-6.26-.1-.7-.18-1.25-.24-1.64s-.07-.56-.07-.56a4.71,4.71,0,0,1,.13.55c.07.39.17.93.29,1.63.27,1.43.66,3.54,1.22,6.24,1.09,5.4,2.79,13.17,5.1,22.67l-.07-.11L140,269.47l.18.15-.13.19-6.48,9.63-3.65,5.41-.13.2-.22-.12L102.32,268.4l-6.08-3.69A38.28,38.28,0,0,1,90.66,261a19.87,19.87,0,0,1-6.31-10.11c-1.71-7.09-3.08-12.82-4-16.79-.45-2-.81-3.49-1.06-4.55L79,228.32A2.92,2.92,0,0,1,78.91,227.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.53,195.33a2.39,2.39,0,0,1,.77-.33,14.59,14.59,0,0,1,2.22-.5,13.15,13.15,0,0,1,7.39,1,14.74,14.74,0,0,1,5.52,5,9,9,0,0,1,1,2.05,2.36,2.36,0,0,1,.18.81,21.06,21.06,0,0,0-1.49-2.65A15.67,15.67,0,0,0,89.68,196a13.81,13.81,0,0,0-7.12-1.1C80.69,195.05,79.56,195.42,79.53,195.33Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpasswordPana);
export default __webpack_public_path__ + "static/media/Reset password-pana.a27ad1a331b20150700408e1a10921fa.svg";
export { ForwardRef as ReactComponent };